<template>
  <img
    :src="logoSrc"
    :alt="alt"
    class="meeting-platform-icon"
    width="28"
    height="28"
  />
</template>

<script>
import {
  KIVO_MEETING_PLATFORM_CONFIG,
} from 'dashboard/constants/kivoMeetingPlatforms';

export default {
  props: {
    platformId: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      default: '',
    },
  },
  computed: {
    logoSrc() {
      const config = Object.values(KIVO_MEETING_PLATFORM_CONFIG).find(
        entry => entry.id === this.platformId
      );
      return config?.logo || '';
    },
  },
};
</script>

<style scoped>
.meeting-platform-icon {
  display: block;
  width: 28px;
  height: 28px;
  object-fit: contain;
}
</style>
